export class InboundTripSendToBrokerTransporterSummaryDto {
  importBranch?: string = undefined
  portOfLading?: string = undefined
  portOfEntry?: string = undefined
  paps: InboundTripSendToBrokerTransporterPAPSSummaryDto[] = []
}

export class InboundTripSendToBrokerTransporterPAPSSummaryDto {
  papsNumber: string = ''
  numberOfVehicles: number = 0
}
